import MaterialCard from "@/components/dashboard/MaterialCard.vue";
import api from "@/api";
import ButtonDialog from "@/components/ButtonDialog.vue";
import DialogCustomView from "@/components/DialogCustomView.vue";
import { ElMessage } from "element-plus";
export default {
  name: "MaterialPage",
  components: {
    DialogCustomView,
    ButtonDialog,
    MaterialCard
  },
  props: {
    boomType: {
      type: Boolean,
      default: false
    }
  },
  data() {
    return {
      netBridgeUrl: null,
      netBridgeVisible: false,
      menus: [],
      shortcuts: [{
        text: '本周',
        value: this.getWeekDateRange()
      }, {
        text: '本月',
        value: this.getMonthDateRange()
      }, {
        text: '近半年',
        value: this.getLastMonthsDateRange(6)
      }, {
        text: '近1年',
        value: this.getLastMonthsDateRange(12)
      }],
      page: 1,
      search: {
        createdTime: null,
        bizType: null,
        creatorId: null,
        platform: null,
        boom: this.boomType,
        title: null,
        page: 0,
        pageSize: 64
      },
      total: 1,
      todayList: [],
      historyList: [],
      users: [],
      params: {
        tags: [],
        bizTypes: [],
        platforms: [],
        scopes: []
      }
    };
  },
  methods: {
    copyNetBridge() {
      try {
        navigator.clipboard.writeText(this.netBridgeUrl);
        ElMessage.success('复制成功');
        this.netBridgeVisible = false;
      } catch (err) {
        ElMessage.error('复制失败');
      }
    },
    onNetBridgeCreated(d) {
      this.netBridgeUrl = d.ret;
      this.netBridgeVisible = true;
    },
    getLastMonthsDateRange(ms) {
      const currentDate = new Date();
      const currentYear = currentDate.getFullYear();
      const currentMonth = currentDate.getMonth();

      // 计算六个月前的年份和月份
      let sixMonthsAgoYear = currentYear;
      let sixMonthsAgoMonth = currentMonth - ms;
      if (sixMonthsAgoMonth < 0) {
        sixMonthsAgoYear -= 1; // 如果月份小于0，则年份减1
        sixMonthsAgoMonth += 12; // 并将月份调整为前一年的相应月份
      }

      // 获取六个月前的日期（同一天）
      const sixMonthsAgoDate = new Date(sixMonthsAgoYear, sixMonthsAgoMonth, currentDate.getDate());

      // 返回日期范围
      return [sixMonthsAgoDate, currentDate];
    },
    getWeekDateRange() {
      const currentDate = new Date();
      const currentDayOfWeek = currentDate.getDay();
      const currentDay = currentDate.getDate();
      const currentMonth = currentDate.getMonth();
      const currentYear = currentDate.getFullYear();

      // JavaScript 中，星期天是 0，星期一是 1，依此类推
      // 计算当前日期距离周一和周日的天数
      const distanceToMonday = currentDayOfWeek === 0 ? -6 : 1 - currentDayOfWeek;
      const distanceToSunday = currentDayOfWeek === 0 ? 0 : 7 - currentDayOfWeek;

      // 计算周一和周日的日期
      const monday = new Date(currentYear, currentMonth, currentDay + distanceToMonday);
      const sunday = new Date(currentYear, currentMonth, currentDay + distanceToSunday);

      // 返回日期范围
      return [monday, sunday];
    },
    getMonthDateRange() {
      const currentDate = new Date();
      const currentYear = currentDate.getFullYear();
      const currentMonth = currentDate.getMonth();

      // 获取当前月份的第一天
      const firstDayOfMonth = new Date(currentYear, currentMonth, 1);

      // 获取下一个月的第一天，然后减去一天，得到当前月份的最后一天
      const firstDayOfNextMonth = new Date(currentYear, currentMonth + 1, 1);
      const lastDayOfMonth = new Date(firstDayOfNextMonth - 1);

      // 返回日期范围
      return [firstDayOfMonth, lastDayOfMonth];
    },
    onTabClick(name, mi, si) {
      let setting = {
        activeTab: name,
        tabIndex: mi,
        subIndex: si
      };
      this.updateDashboard(setting);
    },
    onPageChange(v) {
      this.page = v;
      this.historySearch();
    },
    onPageSizeChange(v) {
      this.search.pageSize = v;
      this.historySearch();
    },
    queryToday() {
      const today = new Date();
      const tomorrow = new Date(today);
      tomorrow.setDate(tomorrow.getDate() + 1);
      const todayyear = today.getFullYear();
      const todaymonth = (today.getMonth() + 1).toString().padStart(2, '0');
      const todayday = today.getDate().toString().padStart(2, '0');
      const year = tomorrow.getFullYear();
      const month = (tomorrow.getMonth() + 1).toString().padStart(2, '0');
      const day = tomorrow.getDate().toString().padStart(2, '0');

      // 返回时间戳范围
      api.listMaterial({
        createdTime: [`${todayyear}-${todaymonth}-${todayday}`, `${year}-${month}-${day}`],
        page: 0,
        pageSize: 100,
        boom: this.boom
      }).then(ret => {
        this.todayList = ret.list;
      });
    },
    resetSearch() {
      this.page = 1;
      this.search = {
        createdTime: null,
        bizType: null,
        creatorId: null,
        platform: null,
        boom: this.boomType,
        title: null,
        page: 0,
        pageSize: 8
      };
      this.historySearch();
    },
    historySearch() {
      this.search.page = this.page - 1;
      api.listMaterial(this.search).then(ret => {
        this.historyList = ret.list;
        this.total = ret.total;
      });
    },
    init() {
      api.getUser4select().then(ret => {
        this.users = ret;
      });
      api.getEditorParams().then(ret => {
        this.params = ret;
      });
      api.getUserInfo().then(ret => {
        this.user = ret;
      });
      this.queryToday();
      this.historySearch();
    }
  },
  mounted() {
    this.init();
  }
};